export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const TRIGGER_LOADING = 'TRIGGER_LOADING';
